import { Component, Injectable, Input, Compiler,ViewChild,OnInit  } from '@angular/core';
import { NgbActiveModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { AlertService } from '../../../../../app/utils/alert.service';
import { DataPackGroup } from '../../../../../app/models/dataPackGroup.model';
import { DataPackLine } from '../../../../../app/models/dataPackLine.model';
import { ConsumeService } from '../../../../../app/services/consume.service';
import { GroupService } from '../../../../../app/services/group.service';
import { BindComponentService } from '../../../../../app/utils/bind.component.service';
import { LoadingComponent } from '../../../../../app/home/paraEmpresas/modalLoading/content.component'; 
import { SaveConsumeComponent } from './content.component';

/**
 * @version $Id$
 */
@Component({
  selector: 'saveConfirmationComponent',
  templateUrl: './content.confirmation.modal.template.html'

})
@Injectable()
export class SaveConfirmationComponent implements OnInit {

  @Input() private payload : any;
  private saving: boolean;


  //@ViewChild(SaveConsumeComponent) saveConsumeComponent: SaveConsumeComponent;

  constructor(private modalService: NgbModal,private bindComponent:BindComponentService,private groupService: GroupService,private activeModal: NgbActiveModal, private consumeService: ConsumeService, private alertService: AlertService) {
  }

  private close() {
    this.activeModal.dismiss();
  }
  
  private openModalLoading() {
    this.modalService.open(LoadingComponent,{       backdrop: 'static',       keyboard: false ,     });
  }


  ngOnInit() {
    //this.saveConsumeComponent.close();
  }

  private save() {
    this.openModalLoading();
    this.saving = true;
    this.groupService.save(this.payload).subscribe(
      data => {
        this.saving = false;
        
        this.activeModal.close();
        this.bindComponent.set(BindComponentService.LOADING_VOICE_CONSUMPTION,true);
        this.bindComponent.set(BindComponentService.LOADING_DATA_CONSUMPTION,true);
        this.alertService.success(data['result']);
    },
      err => {
        this.saving = false;
        this.bindComponent.set(BindComponentService.LOADING_VOICE_CONSUMPTION,false);
        this.activeModal.close();
        this.bindComponent.set(BindComponentService.OPEN_MODAL_LOADING,false);
        this.alertService.error(err.result, err);
      }
    );
  }

}


// WEBPACK FOOTER //
// ./src/app/home/paraEmpresas/consume/save/content.confirmation.component.ts